import React, { ReactNode } from 'react';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';

interface Props {
    children: ReactNode;
    disabled?: boolean;
    handleClick?(): void;
    path: string;
}

const divStyles = {
    active: 'border-b-4 border-primary-500 rounded-full',
    default: 'border-b border-tertiary-200',
    disabled: 'border-b border-tertiary-200',
};

const buttonStyles = {
    default: '',
    active: 'text-primary-500',
    disabled: 'text-tertiary-300',
};

export const TopNavItem = ({
    children,
    disabled = false,
    handleClick,
    path,
}: Props): JSX.Element => {
    const location = useLocation();
    const isActive = path === location.pathname;
    let addDivStyle = isActive ? divStyles.active : divStyles.default;
    let addButtonStyle = isActive ? buttonStyles.active : buttonStyles.default;

    if (disabled) {
        addDivStyle = divStyles.disabled;
        addButtonStyle = buttonStyles.disabled;
    }

    return (
        <span className="flex-initial flex flex-col justify-between h-full">
            <button
                type="button"
                className={cx(
                    'nav-button mt-10 mx-10 text-sm font-semibold',
                    addButtonStyle,
                )}
                disabled={disabled}
                onClick={(): void => {
                    if (!disabled && handleClick) {
                        handleClick();
                    }
                }}
            >
                {children}
            </button>
            <div className={cx('border-solid', addDivStyle)} />
        </span>
    );
};
